// The web app's one api-client instance: cookie mode, same-origin /api/v1 (plan §5 step 4).
// Components never call it directly; they use the TanStack Query hooks in this folder (§5.4).
import { createApiClient } from '@cis/api-client';

export const api = createApiClient();
